import './icons';
import {cookieConsent} from "./partials/cookie-consent";

import {initTestimonialsCarousel} from "./partials/testimonials-carousel";
import {initJobApply} from "./partials/job-apply";
import {initNavigation} from "./partials/navigation";
import {initCategoryFilter} from "./partials/category-filter";
import {initFaq} from "./partials/faq";
import {initHeaderVideo} from "./partials/header-video";

import {Fancybox} from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

//
window.cookieConsent = cookieConsent;

//
Fancybox.bind('[data-fancybox]', {
    'theme': 'light'
});

//
initCategoryFilter();
initTestimonialsCarousel();
initJobApply();
initNavigation();
initFaq();
initHeaderVideo();